import { promiseState } from "../../helper"
import { sacrament } from "../actions/types"

const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},
	detail: {},
}

const sacramentMatrimonyReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(sacrament.GET_MATRIMONY): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(sacrament.GET_MATRIMONY): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(sacrament.GET_MATRIMONY): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(sacrament.GET_MATRIMONY_DETAIL): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(sacrament.GET_MATRIMONY_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(sacrament.GET_MATRIMONY_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		default:
			return state
	}
}

export default sacramentMatrimonyReducer
